'use strict';

exports.__esModule = true;
var transformAggregateReview = exports.transformAggregateReview = function transformAggregateReview(aggregateReview) {
  return aggregateReview && {
    breakdown: {
      oneStarCount: aggregateReview.breakdown && aggregateReview.breakdown['1'] || 0,
      twoStarsCount: aggregateReview.breakdown && aggregateReview.breakdown['2'] || 0,
      threeStarsCount: aggregateReview.breakdown && aggregateReview.breakdown['3'] || 0,
      fourStarsCount: aggregateReview.breakdown && aggregateReview.breakdown['4'] || 0,
      fiveStarsCount: aggregateReview.breakdown && aggregateReview.breakdown['5'] || 0
    },
    averageRating: {
      overall: aggregateReview.average_overallexperience && transformAverageRating(aggregateReview.average_overallexperience) || 0,
      explanation: aggregateReview.average_explanation && transformAverageRating(aggregateReview.average_explanation) || 0,
      bedsideManner: aggregateReview.average_bedsidemanner && transformAverageRating(aggregateReview.average_bedsidemanner) || 0
    },
    reviewsCount: aggregateReview.total_reviews || 0
  } || {};
};

var transformAverageRating = function transformAverageRating(averageRating) {
  return parseFloat(averageRating).toFixed(1);
};


// WEBPACK FOOTER //
// ./components/specialist-page/lib/transformers/aggregate-review.js